module.exports = __webpack_public_path__ + "img/sent_docs.5b5ccaca.svg";